import { OrderStatusCodes } from '@services/orders-service/orders-service';
import {
    appConfigurationProd,
    CountriesByLocale,
} from './app-configuration/app-configuration';
import { ConnectedServicesCountrySelector } from '@models/connected-vehicle';
import RandomNumberUtil from '@utils/random-number-util/random-number-util';

export const DSL_BASE_URL = process.env.REACT_APP_DSL_BASE_URL;

export const DSL_API_PATH = {
    VEHICLE_TYPE: '/fs/api/v3/vehicles/vehicle-type',
    PROFILE_WITH_VEHICLES: '/owner/api/v3/profile',
    ADD_VEHICLE: '/fs/api/v3/vehicles',
    AGGREGATE_POINTS: '/fs/api/v3/loyalty/aggregatedPoints',
    PREFERRED_DEALER_REWARDS:
        '/fs/api/v1/rewards-consumer/customer/vehicle/activity',
    TERMS_AND_CONDITIONS: '/climes/api/v2/terms/owner',
    TERMS_AND_CONDITIONS_BY_FEATURE: '/climes/api/v2/terms',
    TERMS_AND_CONDITIONS_CONSENT: '/owner/api/v2/consents',
    TOKEN_SWAP: '/fs/api/v2/profile/token/swap',
    UPDATE_USER_INFO: '/fs/api/v3/profile',
    UPDATE_USER_ADDRESS: '/owner/api/v3/profile',
    UPDATE_NA_PRIVACY_PREFERENCE: '/fs/api/v2/profile/privacy-preferences',
    GET_PRIVACY_PREFERENCE: '/fs/api/v2/privacy',
    UPDATE_IMG_PRIVACY_PREFERENCE: '/fs/api/v3/privacy-preference',
    UPDATE_PRIVACY_PREFERENCE_V3: '/fs/api/v3/profile/privacy-preferences',
    UPDATE_ECP_PREFERENCE:
        '/scagif/api/v2/marketing/profile-privacy-preference',
    UPDATE_EMAIL: '/scagif/api/v2/marketing/profile-email',
    GET_ECP_PREFERENCES: '/scagif/api/v2/marketing/profile-ecp',
    UNITS_OF_MEASUREMENT: '/fs/api/v2/profile/unit',
    EU_PREFERENCES: '/fs/api/v2/profile/eu-preferences',
    CONSUMER_ID: '/owner/api/v2/consumer-id',
    DELETE_ACCOUNT: '/fs/api/v2/profile/delete-account',
    RESERVATIONS: '/owner/api/v2/reservations',
    MFA_OPTIONS: '/fs/api/v2/profile/mfa',
    CONNECTED_VEHICLE: '/owner/api/v3/vehicle/status',
    EYF_CHECKLIST: '/owner/api/v3/handover/checklist',
    SUBSCRIPTIONS: '/consumer/api/cat/v2/subscriptions',
    PROGNOSTICS: '/fs/api/v3/vehicles/prognostics',
    RECALLS: '/gcamp/api/v5/recalls',
    MNV_OFFER: '/consumer/api/cat/v1/mnv',
    PREFERRED_DEALER: '/nasapi/api/v1/dealer/dealers',
    PROFILE_LITE: '/fs/api/v2/profile/lite',
    BING_DEALERS: '/bing/api/v3/dealers',
    CUSTOMER_ORDER_TRACKING: '/nasapi/api/v1/customer-order/tracking-data',
    CUSTOMER_ORDER_TRACKING_CAT: '/nasapi/api/v2/customer-order/tracking-data',
    WINDOW_STICKER: '/nasapi/api/v1/inventory/windowSticker',
    ADD_DELETED_VEHICLE: '/consumer/api/cat/v1/vehicle/addDeletedVehicle',
    GET_DELETED_VEHICLES: '/consumer/api/cat/v1/vehicle/getDeletedVehicles',
    OSB_DEALER_DETAILS: '/osb/api/public/v1/:locale/dealers',
    OMS_ORDER_HISTORY: '/oms/api/v2/order-history',
    OMS_ORDER_DETAILS: '/oms/api/v3/order-details',
    OMS_ORDER_DETAILS_AUTH: '/oms/api/v3/order-details-auth',
    OMS_RETURN_LABEL: '/oms/api/v1/order-return/label',
    OMS_PACKING_SLIP: '/oms/api/v1/order-return/packing-slip',
    OMS_CREATE_RETURN: '/oms/api/v1/order-return/create',
    OMS_CACHED_LABEL: '/oms/api/v1/order-return/cached-label',
    OMS_CANCEL_ITEM: '/oms/api/v1/cancel-order',
    FEATURE_GUIDE: '/featureguide/api/v3/integrations/generateGuide',
    PREFERRED_DEALER_CONSENT_LEGACY: '/fs/api/v2/privacy',
    PREFERRED_DEALER_CONSENT: '/fs/api/v2/consents',
    NVC_DEALERS: '/oms/api/v1/nvc-dealers',
    OWNERSHIP_DELINK: '/consumer/api/v1/ownershipdelink',
    CVAS_AUTHORIZATION: '/consumer/api/cat/v1/cvas/authorization',
    NUKLEUS_DEALER_SEARCH: '/nasapi/api/v2/dealer-search',
};

export const GOOGLE_MAP_SCRIPT = `https://maps.googleapis.com/maps/api/js?&client=gme-fordmotorcompany2&libraries=places`;
export const EU_BING_KEY =
    'Al1EdZ_aW5T6XNlr-BJxCw1l4KaA0tmXFI_eTl1RITyYptWUS0qit_MprtcG7w2F';
export const EU_BING_BASE_URL =
    'https://spatial.virtualearth.net/REST/v1/data/b15697677d5b40508f1ad2a499d12433/FordHereMaps_Dealers/Dealer';
export const EU_POLYGON =
    '-7.88818359375+63.27318217465046%2C-10.26123046875+55.02802211299252%2C-5.60302734375+53.61857936489517%2C-6.92138671875+50.819818262156545%2C-6.43798828125+47.398349200359256%2C-0.24169921875+49.32512199104001%2C3.18603515625+52.02545860348814%2C0.24169921875+60.930432202923335%2C-1.07666015625+62.81501879409271%2C-7.88818359375+63.27318217465046';
export const CHARGER_ADAPTER_STATUS_QUERY_PARAM =
    '&keyName=chargeradapterstatus';
export const HERE_GEOCODING_API_KEY = process.env.HERE_MAPS_API_KEY;
export const HERE_GEOCODING_BASE_URL =
    'https://geocode.search.hereapi.com/v1/geocode';

export const SESSION_KEY_API_CACHE = 'apiCache';

export const PREFERRED_DEALER_STORAGE_KEY = 'selectedVinPreferredDealer';

export const VEHICLE_CARD_STORAGE_KEY = 'USER_VIN';

export const REWARDS_ACTIVITY_CODE = 'ACTIVITY_CODE';

export const VEHICLE_CARD_SESSION_STORAGE_KEY = 'selectedVin';

export const PREFERRED_DEALER_CONSENT_KEY =
    'Customer Directed Sharing for third party service or product';

export const PREFERRED_DEALER_CONSENTS_LINCOLN_LLID =
    '8fd48941-55bb-4edb-907a-bd8e834a3c44';

export const PREFERRED_DEALER_CONSENTS_LINCOLN_LEGACY_LLID =
    '433dacf3-67f3-4a15-8d9b-68ea3896efb4';

export const PREFERRED_DEALER_CONSENTS_FORD_LLID =
    '9ffb0957-8c89-4c55-b3b0-f012cc3503cb';

export const PREFERRED_DEALER_CONSENTS_FORD_LEGACY_LLID =
    '8699a4e6-22e0-49a1-8325-131c5826495b';

export const PREFERRED_DEALER_CONSENT_ALLOWED_LLIDS = [
    PREFERRED_DEALER_CONSENTS_LINCOLN_LLID,
    PREFERRED_DEALER_CONSENTS_LINCOLN_LEGACY_LLID,
    PREFERRED_DEALER_CONSENTS_FORD_LLID,
    PREFERRED_DEALER_CONSENTS_FORD_LEGACY_LLID,
];

export const getPreferredDealerConsentSubmitLlid = (brand: string): string => {
    return brand?.toLowerCase() === 'lincoln'
        ? PREFERRED_DEALER_CONSENTS_LINCOLN_LLID
        : PREFERRED_DEALER_CONSENTS_FORD_LLID;
};

export const PREFERRED_DEALER_CONSENT_CONTEXT = 10013;
export const PREFERRED_DEALER_CONSENT_CLIMES_FEATURE = {
    ford: 'preferred-dealer-ford',
    lincoln: 'preferred-dealer-lincoln',
} as const;

// defaults to the legacy consent flow until flipped on launch day
export const ENABLE_NEW_PREFERRED_DEALER_CONSENT =
    process.env.REACT_APP_ENABLE_NEW_PREFERRED_DEALER_CONSENT === 'true';

export const ALREADY_DELINKED_API_RESPONSE =
    'Customer already delinked from the specific VIN';

export const BRAND = {
    ford: {
        LONG_NAME: 'ford',
        SHORT_NAME: 'F',
    },
    lincoln: {
        LONG_NAME: 'lincoln',
        SHORT_NAME: 'L',
    },
};

export const GDPR_COOKIE = 'guxfoe-cookiedisclaimer';
export const COOKIE_CONFIGURATION = 'cookie-configuration';

export const DEFAULT_GDPR_COOKIE_VALUE =
    'strictly necessary:yes|performance:yes|functionality:yes|targeting:no';

export const REGIONAL_LOCALES = Array.from(
    new Set(
        appConfigurationProd.countryConfigurations
            .flatMap(
                (countryConfiguration) =>
                    countryConfiguration.regionConfigurations
            )
            .map((config) => config.languageRegionCode)
    )
);

export const PHONE_NUMBER_COUNTRIES: string[] = ['th', 'za', 'ph', 'vn'];

export const DSL_VEHICLE_IMAGE_COUNTRIES = ['USA', 'CAN', 'ARG', 'BRA'];

export const EU_COUNTRIES = [
    'se',
    'gb',
    'ch',
    'de',
    'fr',
    'it',
    'es',
    'no',
    'nl',
    'fi',
    'ie',
    'at',
    'be',
    'lu',
    'pt',
    'dk',
    'cz',
    'gr',
    'hu',
    'pl',
    'ro',
    'ru',
    'tr',
];

export const IMG_COUNTRIES = ['vn', 'au', 'nz', 'ph', 'th', 'za'];

export const SA_COUNTRIES = ['ar', 'br', 've', 'pe', 'co', 'cl'];

export const NA_COUNTRIES = ['us', 'ca'];
export const MX_COUNTRY = ['mx'];

export const ONE_TRUST_COUNTRIES = ['us', 'ca'];

export const SUPPRESS_US_COOKIE_BANNER_COUNTRIES = ['en-ae', 'en-sa', 'en-kw'];
export const CUSTOM_OTP_COUNTRY_PARAMS = [
    { customMarket: 'en-sa', countryCode: 'SAU', uiLocales: 'en-gb' },
];

export const RTL_LANGUAGES = ['ar-ae', 'ar-sa', 'ar-kw'];

export const CHECKOUT_REDIRECT_COUNTRIES = ['en-za'];

export const FP_APP_IDS = {
    STAGE: {
        ANDROID: 'A78654CF-4AF5-11E7-9989-000D3A150356',
        IOS: 'A4E3C521-41C0-4B91-9B0D-6D11C6325A2D',
    },
    PROD: {
        ANDROID: 'BFE8C5ED-D687-4C19-A5DD-F92CDFC4503A',
        IOS: '71A3AD0A-CF46-4CCF-B473-FC7FE5BC4592',
    },
};

export const PERSON_ICON_COUNTRIES: string[] = [
    ...IMG_COUNTRIES,
    ...EU_COUNTRIES,
    ...SA_COUNTRIES,
    ...MX_COUNTRY,
];

export const SYNDICATED_HEADER_COUNTRIES = [
    'mx',
    ...NA_COUNTRIES,
    ...SA_COUNTRIES,
    ...IMG_COUNTRIES,
];

export const SYNDICATED_WRAPPER_COUNTRIES = [
    ...IMG_COUNTRIES,
    'mx',
    ...SA_COUNTRIES,
];

export const SECONDARY_NAV_COUNTRIES = ['us'];

export const CSP_SCRIPT_SOURCES = [
    '*.jquery.com',
    '*.googletagmanager.com',
    '*.gstatic.com',
    '*.google-analytics.com',
    '*.adobedtm.com',
    '*.cookielaw.org',
    '*.liveperson.net',
    '*.liveperson.com',
    '*.lpsnmedia.net',
    '*.iperceptions.com',
    '*.onetrust.com',
    '*.mpeasylink.com',
    '*.onelink-edge.com',
    '*.go-mpulse.net',
    '*.amazonaws.com',
    '*.amitirefinder.com',
    '*.brightcove.net',
    '*.zencdn.net',
    '*.omtrdc.net',
    '*.youtube.com',
    '*.virtualearth.net',
    '*.googleapis.com',
    '*.gstatic.com',
    '*.marketingassociates.com',
    '*.bing.com',
    '*.facebook.net',
    '*.kampyle.com',
    '*.medallia.com',
    '*.googleadservices.com',
    '*.adnxs.com',
    '*.pinimg.com',
    '*.googlesyndication.com',
    '*.convertlanguage.com',
    '*.cardinalcommerce.com',
    '*.bluesnap.com',
    '*.contentsquare.net',
    '*.hotjar.com',
    '*.doubleclick.net',
    '*.stripe.com',
    '*.google.com',
    '*.amplitude.com',
    '*.evgnet.com',
    '*.everestjs.net',
    '*.my.site.com',
    '*.dynatrace.com',
];

export const CSP_DOMAINS = [
    '*.ford.com',
    '*.lincoln.com',
    '*.ford.ca',
    '*.lincolncanada.com',
    '*.ford.co.uk',
    '*.ford.ch',
    '*.ford.de',
    '*.ford.fr',
    '*.ford.it',
    '*.ford.es',
    '*.ford.no',
    '*.ford.nl',
    '*.ford.fi',
    '*.ford.com.br',
    '*.ford.mx',
    '*.lincoln.mx',
    '*.ford.com.ar',
    '*.ford.pl',
    '*.ford.pt',
    '*.ford.ie',
    '*.ford.dk',
    '*.ford.hu',
    '*.ford.ro',
    '*.ford.be',
    '*.ford.lu',
    '*.ford.at',
    '*.ford.gr',
    '*.ford.cz',
    '*.ford.se',
    '*.ford.com.au',
    '*.ford.co.nz',
    '*.ford.co.za',
    '*.ford.com.vn',
    '*.ford.com.ph',
    '*.ford.co.th',
    '*.ford.cl',
    '*.ford.com.co',
    '*.ford.pe',
    '*.ford.com.ve',
];

export const KEYBOARD_KEYS = {
    ESC: 'Escape',
    TAB: 'Tab',
    ENTER: 'Enter',
    END: 'End',
    HOME: 'Home',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_LEFT: 'ArrowLeft',
    SPACE: ' ',
};

export const SESSION_KEYS = {
    PASSKEY_FLOW_RETURN: 'isReturningFromPasskeyFlow',
};

export const SOPHUS_CHAT_COUNTRIES: { [keys: string]: string } = {
    default: 'https://fordlc-qa.s3chat.com/deploy/services.min.js',
    gb: 'https://fordlc-dealer-uk.s3chat.com/deploy/services.min.js',
    nl: 'https://fordlc-nl.s3chat.com/deploy/services.min.js',
};

export const CANCELLED_ORDER_STATUSES: Array<string> = [
    'OCAN',
    'CANCELLED',
    'RESERVATION_CANCELLED',
    'ORDER_CANCELLED',
    'DEALER_REJECTED',
    'DEALER_CANCELLED',
];

export const IMAGE_STORE_ID = {
    ACCESSORY_FORD_STORE_ID: '2201',
    CHARGERS_FORD_STORE_ID: '2202',
    PARTS_FORD_STORE_ID: '1405',
    ACCESSORY_LINCOLN_STORE_ID: '2203',
};

export const ORDER_STATUS_CODES: OrderStatusCodes = {
    us: {
        inProduction: [
            'BWKA',
            'GRTA',
            'OSEQ',
            'STRT',
            'PROD',
            'VASC',
            'VSHP',
            'VDOS',
        ],
        shipped: ['VITR', 'VEHS'],
        purchaseCompleted: ['VAFD'],
        delivered: ['VPHD'],
        cancelled: CANCELLED_ORDER_STATUSES,
    },
    ca: {
        inProduction: [
            'BWKA',
            'GRTA',
            'OSEQ',
            'STRT',
            'PROD',
            'VASC',
            'VSHP',
            'VDOS',
        ],
        shipped: ['VITR', 'VEHS'],
        purchaseCompleted: ['VAFD'],
        delivered: ['VPHD'],
        cancelled: CANCELLED_ORDER_STATUSES,
    },
    eu: {
        inProduction: ['GRTA', 'STRT', 'PROD', 'VASC', 'VSHP', 'VDOS', 'IPRL'],
        shipped: [
            'VAFD',
            'VITR',
            'VPRT',
            'VHLG',
            'VETL',
            'VMOD',
            'VCRB',
            'VAND',
            'VCMP',
            'VEHS',
        ],
        purchaseCompleted: [],
        delivered: ['VPHD'],
        cancelled: CANCELLED_ORDER_STATUSES,
    },
};

export const VALID_ORDER_STATUSES = (regionCode: string): Array<string> => {
    const { inProduction, shipped, purchaseCompleted, delivered } =
        ORDER_STATUS_CODES[regionCode];

    return [...inProduction, ...shipped, ...purchaseCompleted, ...delivered];
};

export const pauseFooter = (): void => {
    const footer: NodeListOf<Element> = document.querySelectorAll(
        'footer, .eu-footer, .footer'
    );
    footer &&
        footer.forEach((element: HTMLElement) => {
            element.style.display = 'none';
        });
};

export const displayHeaderAndFooter = (): void => {
    const headerOrFooter: NodeListOf<Element> = document.querySelectorAll(
        'header, footer, .eu-header, .eu-footer, #global-ux, .footer, .fgx-pantry-bootstrap'
    );
    headerOrFooter &&
        headerOrFooter.forEach((element: HTMLElement) => {
            if (element && element.style.display === 'none') {
                element.style.display = 'block';
            }
        });
};

export const setLocalStorageWithSelectedVIN = (vin: string): void => {
    localStorage.setItem(VEHICLE_CARD_STORAGE_KEY, vin);
};
export const setSessionStorageWithSelectedVIN = (vin: string): void => {
    sessionStorage.setItem(VEHICLE_CARD_SESSION_STORAGE_KEY, vin);
};
export const FALLBACK_VEHICLE_IMAGE_PATH: string =
    process.env.REACT_APP_AEM_BASE_URL +
    '/content/dam/global-account/ga-reimagine-images/fallback-vehicle-image.png?imformat=chrome';
export const FALLBACK_VEHICLE_PROFILE_IMAGE_PATH: string =
    process.env.PUBLIC_URL +
    '/images/fallback-vehicle-image--profile.png?imformat=chrome';
export const LINCOLN_CARD_DEFAULT_IMAGE: string =
    process.env.PUBLIC_URL + '/vehicle-images/default-vehicle.png';
export const CX740_CARD = 'CX740';
export const MAX_VEHICLES_LIMIT = 10;

export const CONNECTED_SERVICES_COUNTRY_SELECTOR: ConnectedServicesCountrySelector =
    {
        options: [
            {
                displayName: 'USA (English)',
                languageRegionCode: 'en-us',
                url: 'https://www.ford.com/myaccount/account-dashboard?connectedservices=true',
                imageUrl: 'us.svg',
            },
            {
                displayName: 'USA (Spanish)',
                languageRegionCode: 'es-us',
                url: 'https://es.ford.com/myaccount/account-dashboard?connectedservices=true',
                imageUrl: 'us.svg',
            },
            {
                displayName: 'België',
                languageRegionCode: 'nl-be',
                url: 'https://www.nl.ford.be/account-management/account-dashboard?connectedservices=true',
                imageUrl: 'be.svg',
            },
            {
                displayName: 'Belgique',
                languageRegionCode: 'fr-be',
                url: 'https://www.fr.ford.be/gestion-de-compte/account-dashboard?connectedservices=true',
                imageUrl: 'be.svg',
            },
            {
                displayName: 'Canada (English)',
                languageRegionCode: 'en-ca',
                url: 'https://www.ford.ca/myaccount/account-dashboard?connectedservices=true',
                imageUrl: 'ca.svg',
            },
            {
                displayName: 'Canada (French)',
                languageRegionCode: 'fr-ca',
                url: 'https://fr.ford.ca/myaccount/account-dashboard?connectedservices=true',
                imageUrl: 'ca.svg',
            },
            {
                displayName: 'Česká republika',
                languageRegionCode: 'cs-cz',
                url: 'https://www.ford.cz/sprava-uctu/account-dashboard?connectedservices=true',
                imageUrl: 'cz.svg',
            },
            {
                displayName: 'Danmark',
                languageRegionCode: 'da-dk',
                url: 'https://www.dkaccount.ford.com/account-dashboard?connectedservices=true',
                imageUrl: 'dk.svg',
            },
            {
                displayName: 'Deutschland',
                languageRegionCode: 'de-de',
                url: 'https://www.ford.de/mein-ford-account/account-dashboard?connectedservices=true',
                imageUrl: 'de.svg',
            },
            {
                displayName: 'Ελλάδα',
                languageRegionCode: 'el-gr',
                url: 'https://www.ford.gr/account-management/account-dashboard?connectedservices=true',
                imageUrl: 'gr.svg',
            },
            {
                displayName: 'Espana',
                languageRegionCode: 'es-es',
                url: 'https://www.ford.es/gestionar-cuenta/account-dashboard?connectedservices=true',
                imageUrl: 'sp.svg',
            },
            {
                displayName: 'France',
                languageRegionCode: 'fr-fr',
                url: 'https://www.ford.fr/gestion-de-compte/account-dashboard?connectedservices=true',
                imageUrl: 'fr.svg',
            },
            {
                displayName: 'Ireland',
                languageRegionCode: 'en-ie',
                url: 'https://www.ford.ie/account-management/account-dashboard?connectedservices=true',
                imageUrl: 'ie.svg',
            },
            {
                displayName: 'Italia',
                languageRegionCode: 'it-it',
                url: 'https://www.ford.it/gestione-account/account-dashboard?connectedservices=true',
                imageUrl: 'it.svg',
            },
            {
                displayName: 'Luxembourg',
                languageRegionCode: 'fr-lu',
                url: 'https://www.ford.lu/gestion-de-compte/account-dashboard?connectedservices=true',
                imageUrl: 'lu.svg',
            },
            {
                displayName: 'Magyarország',
                languageRegionCode: 'hu-hu',
                url: 'https://www.ford.hu/fiokkezeles/account-dashboard?connectedservices=true',
                imageUrl: 'hu.svg',
            },
            {
                displayName: 'Nederland',
                languageRegionCode: 'nl-nl',
                url: 'https://www.ford.nl/accountmanagement/account-dashboard?connectedservices=true',
                imageUrl: 'nl.svg',
            },
            {
                displayName: 'Norge',
                languageRegionCode: 'no-no',
                url: 'https://www.ford.no/konto-administrasjon/account-dashboard?connectedservices=true',
                imageUrl: 'no.svg',
            },
            {
                displayName: 'Österreich',
                languageRegionCode: 'de-at',
                url: 'https://www.ford.at/mein-ford-account/account-dashboard?connectedservices=true',
                imageUrl: 'at.svg',
            },
            {
                displayName: 'Polska',
                languageRegionCode: 'pl-pl',
                url: 'https://www.ford.pl/zarzadzanie-kontem/account-dashboard?connectedservices=true',
                imageUrl: 'pl.svg',
            },
            {
                displayName: 'Portugal',
                languageRegionCode: 'pt-pt',
                url: 'https://www.ford.pt/gestao-de-conta/account-dashboard?connectedservices=true',
                imageUrl: 'pt.svg',
            },
            {
                displayName: 'România',
                languageRegionCode: 'ro-ro',
                url: 'https://www.ford.ro/gestionare-cont/account-dashboard?connectedservices=true',
                imageUrl: 'ro.svg',
            },
            {
                displayName: 'Schweiz',
                languageRegionCode: 'de-ch',
                url: 'https://www.de.ford.ch/mein-ford-account/account-dashboard?connectedservices=true',
                imageUrl: 'ch.svg',
            },
            {
                displayName: 'Suisse',
                languageRegionCode: 'fr-ch',
                url: 'https://www.fr.ford.ch/gestion-de-compte/account-dashboard?connectedservices=true',
                imageUrl: 'ch.svg',
            },
            {
                displayName: 'Svizzera',
                languageRegionCode: 'it-ch',
                url: 'https://www.it.ford.ch/gestione-account/account-dashboard?connectedservices=true',
                imageUrl: 'ch.svg',
            },
            {
                displayName: 'Suomi',
                languageRegionCode: 'fi-fi',
                url: 'https://www.ford.fi/tilin-hallinta/account-dashboard?connectedservices=true',
                imageUrl: 'fi.svg',
            },
            {
                displayName: 'Sverige',
                languageRegionCode: 'sv-se',
                url: 'https://www.seaccount.ford.com/account-dashboard?connectedservices=true',
                imageUrl: 'se.svg',
            },
            {
                displayName: 'United Kingdom',
                languageRegionCode: 'en-gb',
                url: 'https://www.ford.co.uk/account-management/account-dashboard?connectedservices=true',
                imageUrl: 'gb.svg',
            },
        ],
    };
const gccCountry = (
    languageName: string,
    twoLetterCountryCode: string,
    threeLetterCountryCode: string
) => ({ languageName, twoLetterCountryCode, threeLetterCountryCode });

export const NON_GA_COUNTRIES: CountriesByLocale = {
    'en-bg': {
        languageName: 'English',
        twoLetterCountryCode: 'bg',
        threeLetterCountryCode: 'bgr',
    },
    'en-hr': {
        languageName: 'English',
        twoLetterCountryCode: 'hr',
        threeLetterCountryCode: 'hrv',
    },
    'en-ee': {
        languageName: 'English',
        twoLetterCountryCode: 'ee',
        threeLetterCountryCode: 'est',
    },
    'en-is': {
        languageName: 'English',
        twoLetterCountryCode: 'is',
        threeLetterCountryCode: 'isl',
    },
    'da-is': {
        languageName: 'Danish',
        twoLetterCountryCode: 'is',
        threeLetterCountryCode: 'isl',
    },
    'en-lv': {
        languageName: 'English',
        twoLetterCountryCode: 'lv',
        threeLetterCountryCode: 'lva',
    },
    'de-li': {
        languageName: 'German',
        twoLetterCountryCode: 'li',
        threeLetterCountryCode: 'lie',
    },
    'en-lt': {
        languageName: 'English',
        twoLetterCountryCode: 'lt',
        threeLetterCountryCode: 'ltu',
    },
    'en-sk': {
        languageName: 'English',
        twoLetterCountryCode: 'sk',
        threeLetterCountryCode: 'svk',
    },
    'sk-sk': {
        languageName: 'Slovak',
        twoLetterCountryCode: 'sk',
        threeLetterCountryCode: 'svk',
    },
    'en-si': {
        languageName: 'English',
        twoLetterCountryCode: 'si',
        threeLetterCountryCode: 'svn',
    },
    'sl-si': {
        languageName: 'Slovenian',
        twoLetterCountryCode: 'si',
        threeLetterCountryCode: 'svn',
    },
    'en-cy': {
        languageName: 'English',
        twoLetterCountryCode: 'cy',
        threeLetterCountryCode: 'cyp',
    },
    'de-lu': {
        languageName: 'German',
        twoLetterCountryCode: 'lu',
        threeLetterCountryCode: 'lux',
    },
    'it-mt': {
        languageName: 'Italian',
        twoLetterCountryCode: 'mt',
        threeLetterCountryCode: 'mlt',
    },
    'en-mt': {
        languageName: 'English',
        twoLetterCountryCode: 'mt',
        threeLetterCountryCode: 'mlt',
    },
    'fr-mc': {
        languageName: 'French',
        twoLetterCountryCode: 'mc',
        threeLetterCountryCode: 'mco',
    },
    'fr-li': {
        languageName: 'French',
        twoLetterCountryCode: 'li',
        threeLetterCountryCode: 'lie',
    },
    'it-li': {
        languageName: 'Italian',
        twoLetterCountryCode: 'li',
        threeLetterCountryCode: 'lie',
    },
    'tr-tr': {
        languageName: 'Turkish',
        twoLetterCountryCode: 'tr',
        threeLetterCountryCode: 'tur',
    },
    'en-tr': {
        languageName: 'English',
        twoLetterCountryCode: 'tr',
        threeLetterCountryCode: 'tur',
    },
    'en-bw': {
        languageName: 'English',
        twoLetterCountryCode: 'bw',
        threeLetterCountryCode: 'bwa',
    },
    'en-ls': {
        languageName: 'English',
        twoLetterCountryCode: 'ls',
        threeLetterCountryCode: 'lso',
    },
    'en-sz': {
        languageName: 'English',
        twoLetterCountryCode: 'sz',
        threeLetterCountryCode: 'swz',
    },
    'en-na': {
        languageName: 'English',
        twoLetterCountryCode: 'na',
        threeLetterCountryCode: 'nam',
    },
    'en-in': {
        languageName: 'English',
        twoLetterCountryCode: 'in',
        threeLetterCountryCode: 'ind',
    },
    'en-vn': {
        languageName: 'English',
        twoLetterCountryCode: 'vn',
        threeLetterCountryCode: 'vnm',
    },
    // Single-line entries to avoid tripping duplication detection against the object-literal entries above.
    'en-kw': gccCountry('English', 'kw', 'kwt'),
    'ar-kw': gccCountry('Arabic', 'kw', 'kwt'),
    'en-sa': gccCountry('English', 'sa', 'sau'),
    'ar-sa': gccCountry('Arabic', 'sa', 'sau'),
    'en-ae': gccCountry('English', 'ae', 'are'),
    'ar-ae': gccCountry('Arabic', 'ae', 'are'),
};

export const FORDPASS_AUTHORIZED_DEEPLINK = 'fordapp://userauthorized';
export const LINCOLNWAY_AUTHORIZED_DEEPLINK = 'lincolnapp://userauthorized';
export const FORDPASS_PREFERENCES_DEEPLINK = 'fordapp://preferences';

export const RANDOM_EU_VINS: Array<string> = [
    'WF0ZXXTTGZLY77413',
    'WF0ZXXTTGZLY77406',
    'WF0NXXGCHNLE16235',
    'WF0JXXWPCJLY77387',
    'WF0FXXWPMFLY76276',
    'WF0JXXGAHJLY51628',
    'WF0EXXTTREKU80643',
    'WF0KXXTTRKLK59311',
    'WF0JXXWPCJLY81324',
    'WF0PXXGCHPLY64370',
    'WF01XXERK1LL71335',
    'WF0RXXWPGRLL49432',
];

export const EU_VPHD_FAKE_VIN = 'WF0FXXWPMFLB59456';

export const generateRandomEuVin = (): string => {
    return RANDOM_EU_VINS[
        Math.floor(RandomNumberUtil.getRandomNumber() * RANDOM_EU_VINS.length)
    ];
};

export const DIG_PROD_URL = 'https://build.ford.com/dig/';
export const DIG_QA_URL = 'https://wwwqa.build.ford.com/dig/';

export const NUMBER_OF_TRACKER_STEPS = 6;

export const CVOT_IMAGE_URL_BASE = 'https://shop.ford.com/cmslibs';

export const modelPartClassNameList: string[] = [
    'Engine',
    'Transmissions',
    'Drive',
    'ModelGroup',
];
export const exteriorPartClassNameList: string[] = [
    'Exterior Options',
    'Paint Type',
    'Mirror Options',
    'BodyStyle',
    'Paint Applications',
    'Running Boards',
    'Accessory Running Boards',
    'Roof Color',
    'Rear Axle Ratios',
    'Wheel Type',
    'Tire Type',
    'Accessory Wheels',
    'Racing Stripe',
    'Hood Side Stripes',
];
export const interiorPartClassNameList: string[] = [
    'Interior Options',
    'Interior Trim Colour',
    'Interior Packages',
    'Radio Type',
    'Audio Upgrade',
    'Seat Type',
    '2nd Row Seats',
    '3rd Row Seats',
];
export const accessoriesPartClassNameList: string[] = [
    'Appearance',
    'Bed Products',
    'Electronics',
    'Exterior Accessories',
    'Interior Accessories',
    'Hood and Side Stripes',
    'Options',
];
export const packagesPartClassNameList: string[] = [
    'Pep Code',
    'Special Package',
];

export enum LinkTargetValues {
    SELF = '_self',
    BLANK = '_blank',
    PARENT = '_parent',
    TOP = '_top',
}

export const DAY_MONTH_YEAR_REGIONS = ['fr-ca'];

export const C3_OPT_DOWN_LOCALES = ['en-us', 'es-us'];

export const CA_EDITABLE_ECP_LOCALES = ['en-ca', 'fr-ca'];

export const INSTALL_LINES_ID = '1N5TA11';

export const EU_CHAT_BOT_URLS = {
    DSE_CHAT_BOT_CONFIGURATION: 'https://ito028502.hosts.cloud.ford.com:5434',
    PERF_CHAT_BOT_BUNDLE_JS:
        'https://wwwstg.dse-chatbot.ford.com/build/dist/bundle.js',
    PERF_CHAT_BOT_BUNDLE_CSS:
        'https://wwwstg.dse-chatbot.ford.com/build/dist/bundle.css',
    PROD_CHAT_BOT_BUNDLE_JS:
        'https://www.dse-chatbot.ford.com/build/dist/bundle.js',
    PROD_CHAT_BOT_BUNDLE_CSS:
        'https://www.dse-chatbot.ford.com/build/dist/bundle.css',
    FORD_ANTENNA_SWAP_CSS:
        '//www.ford.eu/static/prod/fonts/ford-antenna-swap.css',
    FORD_ICONS_CSS: '//www.ford.eu/static/prod/ford-icons/ford-icons.css',
    FORD_VARIABLES_CSS: '//www.ford.eu/static/prod/tokens/_variables.css',
};

export const NEW_EU_HELP_ROUTER_MARKETS = {
    ford: {
        supportedMarkets: [
            {
                languageRegionCode: 'en_gb',
                countryCode: 'uk',
                isUrlWithBeta: true,
            },
            {
                languageRegionCode: 'en_ie',
                countryCode: 'ie',
                isUrlWithBeta: false,
            },
            {
                languageRegionCode: 'hu_hu',
                countryCode: 'hu',
                isUrlWithBeta: false,
            },
            {
                languageRegionCode: 'es_es',
                countryCode: 'es',
                isUrlWithBeta: true,
            },
            {
                languageRegionCode: 'pt_pt',
                countryCode: 'pt',
                isUrlWithBeta: true,
            },
            {
                languageRegionCode: 'it_it',
                countryCode: 'it',
                isUrlWithBeta: true,
            },
            {
                languageRegionCode: 'fr_fr',
                countryCode: 'fr',
                isUrlWithBeta: true,
            },
            {
                languageRegionCode: 'no_no',
                countryCode: 'no',
                isUrlWithBeta: true,
            },
            {
                languageRegionCode: 'nl_be',
                countryCode: 'be',
                isUrlWithBeta: false,
            },
            {
                languageRegionCode: 'fr_be',
                countryCode: 'be',
                isUrlWithBeta: false,
            },
            {
                languageRegionCode: 'pl_pl',
                countryCode: 'pl',
                isUrlWithBeta: true,
            },
            {
                languageRegionCode: 'cs_cz',
                countryCode: 'cz',
                isUrlWithBeta: false,
            },
            {
                languageRegionCode: 'ro_ro',
                countryCode: 'ro',
                isUrlWithBeta: false,
            },
            {
                languageRegionCode: 'nl_nl',
                countryCode: 'nl',
                isUrlWithBeta: true,
            },
            {
                languageRegionCode: 'de_de',
                countryCode: 'de',
                isUrlWithBeta: true,
            },
            {
                languageRegionCode: 'de_at',
                countryCode: 'at',
                isUrlWithBeta: true,
            },
            {
                languageRegionCode: 'de_ch',
                countryCode: 'ch',
                isUrlWithBeta: false,
            },
            {
                languageRegionCode: 'fr_ch',
                countryCode: 'ch',
                isUrlWithBeta: false,
            },
            {
                languageRegionCode: 'it_ch',
                countryCode: 'ch',
                isUrlWithBeta: false,
            },
            // {
            //     languageRegionCode: 'el_gr',
            //     countryCode: 'gr',
            //     isUrlWithBeta: false,
            // },
        ],
    },
};

export const US_STATES: string[] = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
];

export const CA_PROVINCES: string[] = [
    'AB',
    'BC',
    'MB',
    'NB',
    'NL',
    'NT',
    'NS',
    'NU',
    'ON',
    'PE',
    'QC',
    'SK',
    'YT',
];

export const isValidPreferredDealerForMarket = (
    currentCountryCode: string,
    state: string
): boolean => {
    const isValidUSLocation =
        currentCountryCode === 'us' && US_STATES.includes(state);
    const isValidCALocation =
        currentCountryCode === 'ca' && CA_PROVINCES.includes(state);

    return Boolean(isValidUSLocation || isValidCALocation);
};

export const PKCE = {
    VERIFIER: 'fma_verifier',
    CHALLENGE: 'fma_challenge',
};

export const SQUARE_IMAGE_RATIO_LOWER_BOUND = 0.8;
export const SQUARE_IMAGE_RATIO_UPPER_BOUND = 1.2;
